module.exports = __webpack_public_path__ + "static/media/parking.91fa72d3.png";